import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import moment from 'moment';
import {
  TabContent, TabPane, Nav, NavItem, NavLink,
  PopoverHeader, UncontrolledPopover, Modal,
  ModalBody, ModalHeader,
  ModalFooter,
} from 'reactstrap';

import Form from '../../../components/form/form';
import OneClickButton from '../../../components/form/button';

import { getPageLayout, updatePageLayout } from '../../../app/store/actions/pageLayout';

import { Panel, PanelBody } from '../../../components/panel/panel';
import DateRangePicker from '../../../components/date/DateRangePicker.jsx';
import addNotification from '../../../components/notification';

import List from './list';

import WikiHelp from '../../../components/tooltip/wikiHelp';
import ROUTES from '../../../config/routes';
import Permissions from '../../../app/services/permissions';

class OutboundMonitor extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: 'pendingCut',
      startDate: moment().subtract(30, 'days'),
      endDate: moment(),
      currentRange: `${moment().subtract(30, 'days').format('DD MMM YYYY')} - ${moment().format('DD MMM YYYY')}`,
      usesCableCuttingPlan: false,
      showModalPageLayout: false,
      pageLayout: {
        showLoadNumber: true,
        showDeliveryDate: true,
        showCustomerOrderCode: true,
        showCustomer: true,
        showInvoiceNumber: true,
        showOrderType: true,
        showUrgent: true,
        showPriority: true,
        showPickingType: true,
        showCreatedAt: true,
        showDeliveryType: true,
        showCarrier: true,
        showPickedUser: true,
        showPickedAt: true,
        showCheckedUser: true,
        showCheckedAt: true,
        showConsolidationUser: true,
        showConsolidationAt: true,
        showRepresentative: true,
        showNote: true,
        showProductDescription: true,
        showProductUnitMeasure: true,
        showProductQuantity: true,
        showProductBaptism: true,
        showProductPickedQuantity: true,
        showProductPickedUser: true,
        showProductPickedAt: true,
        showProductCheckedQuantity: true,
        showProductCheckedUser: true,
        showProductCheckedAt: true,
        showProductStatus: true,
        showTotalWeight: true,
        showProductComplementCode: true,
      },
      showLoadNumber: true,
      showDeliveryDate: true,
      showCustomerOrderCode: true,
      showCustomer: true,
      showInvoiceNumber: true,
      showOrderType: true,
      showUrgent: true,
      showPriority: true,
      showPickingType: true,
      showCreatedAt: true,
      showDeliveryType: true,
      showCarrier: true,
      showPickedUser: true,
      showPickedAt: true,
      showCheckedUser: true,
      showCheckedAt: true,
      showConsolidationUser: true,
      showConsolidationAt: true,
      showRepresentative: true,
      showNote: true,
      showProductDescription: true,
      showProductUnitMeasure: true,
      showProductQuantity: true,
      showProductBaptism: true,
      showProductPickedQuantity: true,
      showProductPickedUser: true,
      showProductPickedAt: true,
      showProductCheckedQuantity: true,
      showProductCheckedUser: true,
      showProductCheckedAt: true,
      showProductStatus: true,
      showTotalWeight: true,
      showProductComplementCode: true,
    };

    this.styleNavLink = {
      flexGrow: 1,
      display: 'flex !important',
      justifyContent: 'center',
      alignItems: 'center',
    };

    this.styleSpan = {
      height: '36px',
    };
  }

  async componentDidMount() {
    await this.getUsesCableCuttingplan();
    await this.getPageLayout();
  }

  async componentDidUpdate(prevProps) {
    if ((prevProps.user && prevProps.user.mainBranchData) !== (this.props.user && this.props.user.mainBranchData)) {
      await this.getUsesCableCuttingplan();
      await this.getPageLayout();
    }
  }

  setValue = async (attr, value) => {
    this.setState({
      [`${attr}`]: value,
    });
  };

  getUsesCableCuttingplan = async () => {
    const { user } = this.props;

    if (user && user.mainBranchData) {
      const { mainBranchData } = user;
      const { usesCableCuttingPlan } = mainBranchData;

      this.setState({
        usesCableCuttingPlan,
        activeTab: usesCableCuttingPlan ? 'pendingCut' : 'pendingPicking',
      });
    }
  };

  toggleFilter = (activeTab) => {
    this.setState({
      activeTab,
    });
  };

  showPageLayoutModal = () => {
    this.setState({
      showModalPageLayout: true,
    });
  };

  closePageLayoutModal = () => {
    this.getPageLayout();
    this.setState({
      showModalPageLayout: false,
    });
  };

  getPageLayout = async () => {
    const { user } = this.props;

    if (user && user.mainBranchData) {
      const { mainBranchData } = user;

      const layoutSelected = await this.props.getPageLayout({
        branchCode: mainBranchData.code,
        page: this.props.location.pathname,
      });

      if (layoutSelected && layoutSelected.layout) {
        this.setState({
          pageLayout: {
            ...layoutSelected.layout,
            showTotalWeight: layoutSelected.layout.showTotalWeight ?? true,
          },
          showLoadNumber: layoutSelected.layout.showLoadNumber,
          showDeliveryDate: layoutSelected.layout.showDeliveryDate,
          showCustomerOrderCode: layoutSelected.layout.showCustomerOrderCode,
          showCustomer: layoutSelected.layout.showCustomer,
          showInvoiceNumber: layoutSelected.layout.showInvoiceNumber,
          showOrderType: layoutSelected.layout.showOrderType,
          showUrgent: layoutSelected.layout.showUrgent,
          showPriority: layoutSelected.layout.showPriority,
          showPickingType: layoutSelected.layout.showPickingType,
          showCreatedAt: layoutSelected.layout.showCreatedAt,
          showDeliveryType: layoutSelected.layout.showDeliveryType,
          showCarrier: layoutSelected.layout.showCarrier,
          showPickedUser: layoutSelected.layout.showPickedUser,
          showPickedAt: layoutSelected.layout.showPickedAt,
          showCheckedUser: layoutSelected.layout.showCheckedUser,
          showCheckedAt: layoutSelected.layout.showCheckedAt,
          showConsolidationUser: layoutSelected.layout.showConsolidationUser,
          showConsolidationAt: layoutSelected.layout.showConsolidationAt,
          showRepresentative: layoutSelected.layout.showRepresentative,
          showNote: layoutSelected.layout.showNote,
          showProductDescription: layoutSelected.layout.showProductDescription,
          showProductUnitMeasure: layoutSelected.layout.showProductUnitMeasure,
          showProductQuantity: layoutSelected.layout.showProductQuantity,
          showProductBaptism: layoutSelected.layout.showProductBaptism,
          showProductPickedQuantity: layoutSelected.layout.showProductPickedQuantity,
          showProductPickedUser: layoutSelected.layout.showProductPickedUser,
          showProductPickedAt: layoutSelected.layout.showProductPickedAt,
          showProductCheckedQuantity: layoutSelected.layout.showProductCheckedQuantity,
          showProductCheckedUser: layoutSelected.layout.showProductCheckedUser,
          showProductCheckedAt: layoutSelected.layout.showProductCheckedAt,
          showProductStatus: layoutSelected.layout.showProductStatus,
          showTotalWeight: layoutSelected.layout.showTotalWeight ?? true,
          showProductComplementCode: layoutSelected.layout.showProductComplementCode,
        });
      }
    }
  };

  updatePageLayoutArray = () => {
    const {
      showLoadNumber,
      showDeliveryDate,
      showCustomerOrderCode,
      showCustomer,
      showInvoiceNumber,
      showOrderType,
      showUrgent,
      showPriority,
      showPickingType,
      showCreatedAt,
      showDeliveryType,
      showCarrier,
      showPickedUser,
      showPickedAt,
      showCheckedUser,
      showCheckedAt,
      showConsolidationUser,
      showConsolidationAt,
      showRepresentative,
      showNote,
      showProductDescription,
      showProductUnitMeasure,
      showProductQuantity,
      showProductBaptism,
      showProductPickedQuantity,
      showProductPickedUser,
      showProductPickedAt,
      showProductCheckedQuantity,
      showProductCheckedUser,
      showProductCheckedAt,
      showProductStatus,
      showTotalWeight,
      showProductComplementCode,
    } = this.state;

    const layout = {
      showLoadNumber,
      showDeliveryDate,
      showCustomerOrderCode,
      showCustomer,
      showInvoiceNumber,
      showOrderType,
      showUrgent,
      showPriority,
      showPickingType,
      showCreatedAt,
      showDeliveryType,
      showCarrier,
      showPickedUser,
      showPickedAt,
      showCheckedUser,
      showCheckedAt,
      showConsolidationUser,
      showConsolidationAt,
      showRepresentative,
      showNote,
      showProductDescription,
      showProductUnitMeasure,
      showProductQuantity,
      showProductBaptism,
      showProductPickedQuantity,
      showProductPickedUser,
      showProductPickedAt,
      showProductCheckedQuantity,
      showProductCheckedUser,
      showProductCheckedAt,
      showProductStatus,
      showTotalWeight,
      showProductComplementCode,
    };

    try {
      const { user } = this.props;
      if (user && user.mainBranchData) {
        const { mainBranchData } = user;

        const updLayout = this.props.updatePageLayout({
          branchCode: mainBranchData.code,
          page: this.props.location.pathname,
          layout,
        });

        if (updLayout) {
          addNotification(
            'success',
            I18n.t('BEE4440' /* Atualizar Layout da Página */),
            I18n.t('BEE4442' /* Atualização do Layout de Página efetuada com sucesso! */),
            'top-right',
          );

          this.setState({
            pageLayout: layout,
          });
        }
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        const { error } = err.response.data;

        if (error.details || error.message) {
          addNotification(
            'danger',
            I18n.t('BEE4440' /* Atualizar Layout da Página */),
            `${error.code} - ${error.message}`,
            'top-right',
          );
        } else {
          addNotification(
            'danger',
            I18n.t('BEE4440' /* Atualizar Layout da Página */),
            I18n.t('BEE4441' /* Erro ao atualizar o Layout de Página */),
            'top-right',
          );
        }
      } else {
        addNotification(
          'danger',
          I18n.t('BEE4440' /* Atualizar Layout da Página */),
          I18n.t('BEE4441' /* Erro ao atualizar o Layout de Página */),
          'top-right',
        );
      }
    }

    this.setState({
      showModalPageLayout: false,
    });
  };

  createPageLayoutModal = () => {
    const {
      showModalPageLayout, showLoadNumber,
      showDeliveryDate, showCustomerOrderCode, showCustomer, showInvoiceNumber, showOrderType,
      showUrgent, showPriority, showPickingType, showCreatedAt, showDeliveryType,
      showCarrier, showPickedUser, showPickedAt, showCheckedUser, showCheckedAt,
      showConsolidationUser, showConsolidationAt, showRepresentative, showNote,
      showProductDescription, showProductUnitMeasure, showProductQuantity, showProductBaptism,
      showProductPickedQuantity, showProductPickedUser, showProductPickedAt, showProductCheckedQuantity,
      showProductCheckedUser, showProductCheckedAt, showProductStatus, showTotalWeight, showProductComplementCode,
    } = this.state;

    return (
      <Modal
        size="md"
        isOpen={showModalPageLayout}
        toggle={() => this.closePageLayoutModal()}
      >
        <ModalHeader toggle={() => this.closePageLayoutModal()}>
          <span className="text-center">
            {I18n.t('BEE4439' /* Gerenciar Colunas */).toLocaleUpperCase()}
          </span>
        </ModalHeader>
        <ModalBody>
          <div className="col-md-12 text-right">
            <div className="d-flex align-items-center mb-md-3 mb-1">
              <h1 className="page-header mb-0">
                {I18n.t('BEE1378' /* Documento */)}
              </h1>
            </div>
            <div className="d-flex flex-column align-items-left m-5 p-5">
              <Form
                noPanel
                setValue={this.setValue}
                setValueDrop={this.setValueDrop}
                inputs={(formContext) => ([
                  formContext.createToggleBox(
                    showLoadNumber,
                    'showLoadNumber',
                    I18n.t('BEE4526' /* Carga */),
                  ),
                  formContext.createToggleBox(
                    showTotalWeight,
                    'showTotalWeight',
                    I18n.t('BEE4488' /* Peso (kg) */),
                  ),
                  formContext.createToggleBox(
                    showDeliveryDate,
                    'showDeliveryDate',
                    I18n.t('BEE444' /* Data de Entrega */),
                  ),
                  formContext.createToggleBox(
                    showCustomerOrderCode,
                    'showCustomerOrderCode',
                    I18n.t('BEE1096' /* Pedido cliente */),
                  ),
                  formContext.createToggleBox(
                    showCustomer,
                    'showCustomer',
                    I18n.t('BEE50' /* Cliente */),
                  ),
                  formContext.createToggleBox(
                    showInvoiceNumber,
                    'showInvoiceNumber',
                    I18n.t('BEE402' /* Nota Fiscal */),
                  ),
                  formContext.createToggleBox(
                    showOrderType,
                    'showOrderType',
                    I18n.t('BEE200' /* Tipo */),
                  ),
                  formContext.createToggleBox(
                    showUrgent,
                    'showUrgent',
                    I18n.t('BEE613' /* Urgente */),
                  ),
                  formContext.createToggleBox(
                    showPriority,
                    'showPriority',
                    I18n.t('BEE4115' /* Prioridade */),
                  ),
                  formContext.createToggleBox(
                    showPickingType,
                    'showPickingType',
                    I18n.t('BEE43' /* Separação */),
                  ),
                  formContext.createToggleBox(
                    showCreatedAt,
                    'showCreatedAt',
                    I18n.t('BEE1763' /* Data Documento */),
                  ),
                  formContext.createToggleBox(
                    showDeliveryType,
                    'showDeliveryType',
                    I18n.t('BEE1057' /* Entrega */),
                  ),
                  formContext.createToggleBox(
                    showCarrier,
                    'showCarrier',
                    I18n.t('BEE301' /* Transportadora */),
                  ),
                  formContext.createToggleBox(
                    showPickedUser,
                    'showPickedUser',
                    I18n.t('BEE1092' /* Separador */),
                  ),
                  formContext.createToggleBox(
                    showPickedAt,
                    'showPickedAt',
                    I18n.t('BEE1721' /* Data Separação */),
                  ),
                  formContext.createToggleBox(
                    showCheckedUser,
                    'showCheckedUser',
                    I18n.t('BEE805' /* Conferente */),
                  ),
                  formContext.createToggleBox(
                    showCheckedAt,
                    'showCheckedAt',
                    I18n.t('BEE467' /* Data Conferência */),
                  ),
                  formContext.createToggleBox(
                    showConsolidationUser,
                    'showConsolidationUser',
                    I18n.t('BEE2089' /* Consolidado */),
                  ),
                  formContext.createToggleBox(
                    showConsolidationAt,
                    'showConsolidationAt',
                    I18n.t('BEE2095' /* Data Consolidação */),
                  ),
                  formContext.createToggleBox(
                    showRepresentative,
                    'showRepresentative',
                    I18n.t('BEE1374' /* Vendedor */),
                  ),
                  formContext.createToggleBox(
                    showNote,
                    'showNote',
                    I18n.t('BEE135' /* Observação */),
                  ),
                ])}
              />
            </div>
            <hr />
            <div className="d-flex align-items-center mb-md-3 mb-1">
              <h1 className="page-header mb-0">
                {I18n.t('BEE27' /* Produtos */)}
              </h1>
            </div>
            <div className="d-flex flex-column align-items-left m-5 p-5">
              <Form
                noPanel
                setValue={this.setValue}
                setValueDrop={this.setValueDrop}
                inputs={(formContext) => ([
                  formContext.createToggleBox(
                    showProductComplementCode,
                    'showProductComplementCode',
                    I18n.t('BEE695' /* Código Complementar */),
                  ),
                  formContext.createToggleBox(
                    showProductDescription,
                    'showProductDescription',
                    I18n.t('BEE1897' /* Descrição */),
                  ),
                  formContext.createToggleBox(
                    showProductUnitMeasure,
                    'showProductUnitMeasure',
                    I18n.t('BEE384' /* Unidade */),
                  ),
                  formContext.createToggleBox(
                    showProductQuantity,
                    'showProductQuantity',
                    I18n.t('BEE441' /* Quantidade */),
                  ),
                  formContext.createToggleBox(
                    showProductBaptism,
                    'showProductBaptism',
                    I18n.t('BEE425' /* Batismo */),
                  ),
                  formContext.createToggleBox(
                    showProductPickedQuantity,
                    'showProductPickedQuantity',
                    I18n.t('BEE2040' /* Separada */),
                  ),
                  formContext.createToggleBox(
                    showProductPickedUser,
                    'showProductPickedUser',
                    I18n.t('BEE1092' /* Separador */),
                  ),
                  formContext.createToggleBox(
                    showProductPickedAt,
                    'showProductPickedAt',
                    I18n.t('BEE1721' /* Data Separação */),
                  ),
                  formContext.createToggleBox(
                    showProductCheckedQuantity,
                    'showProductCheckedQuantity',
                    I18n.t('BEE464' /* Conferida */),
                  ),
                  formContext.createToggleBox(
                    showProductCheckedUser,
                    'showProductCheckedUser',
                    I18n.t('BEE805' /* Conferente */),
                  ),
                  formContext.createToggleBox(
                    showProductCheckedAt,
                    'showProductCheckedAt',
                    I18n.t('BEE467' /* Data Conferência */),
                  ),
                  formContext.createToggleBox(
                    showProductStatus,
                    'showProductStatus',
                    I18n.t('BEE224' /* Status */),
                  ),
                ])}
              />
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <div className="d-flex justify-content-between w-100">
            <button
              type="button"
              className="btn btn-120 btn-primary p-5 m-5"
              onClick={this.resetLayout}
            >
              {I18n.t('BEE4443' /* Restaurar padrão */)}
            </button>
            <div>
              <OneClickButton
                type="button"
                className="btn btn-120 btn-white p-5 m-5"
                onClick={this.closePageLayoutModal}
              >
                {I18n.t('BEE99' /* Cancelar */)}
              </OneClickButton>
              <OneClickButton
                type="button"
                className="btn btn-120 btn-primary p-5 m-5"
                onClick={this.updatePageLayoutArray}
              >
                {I18n.t('BEE139' /* Atualizar */)}
              </OneClickButton>
            </div>
          </div>
        </ModalFooter>
      </Modal>
    );
  };

  resetLayout = () => {
    this.setState({
      showLoadNumber: true,
      showDeliveryDate: true,
      showCustomerOrderCode: true,
      showCustomer: true,
      showInvoiceNumber: true,
      showOrderType: true,
      showUrgent: true,
      showPriority: true,
      showPickingType: true,
      showCreatedAt: true,
      showDeliveryType: true,
      showCarrier: true,
      showPickedUser: true,
      showPickedAt: true,
      showCheckedUser: true,
      showCheckedAt: true,
      showConsolidationUser: true,
      showConsolidationAt: true,
      showRepresentative: true,
      showNote: true,
      showProductDescription: true,
      showProductUnitMeasure: true,
      showProductQuantity: true,
      showProductBaptism: true,
      showProductPickedQuantity: true,
      showProductPickedUser: true,
      showProductPickedAt: true,
      showProductCheckedQuantity: true,
      showProductCheckedUser: true,
      showProductCheckedAt: true,
      showProductStatus: true,
      showTotalWeight: true,
    });
  };

  handleDateApplyEvent = async (event) => {
    const startDate = moment(event[0]);
    const endDate = moment(event[1]);
    const currentRange = `${startDate.format('DD MMM YYYY')} - ${endDate.format('DD MMM YYYY')}`;

    await this.setState({
      startDate,
      endDate,
      currentRange,
    });
  };

  render() {
    const {
      activeTab, startDate, endDate, currentRange, usesCableCuttingPlan, pageLayout,
    } = this.state;

    const {
      styleNavLink, styleSpan,
    } = this;

    return (
      <div className="slideUpTransition">
        <div className="d-flex align-items-center">
          <ol className="breadcrumb float-xl-left">
            <li className="breadcrumb-item">
              <i className="fas fa-home fa-fw m-t-10 m-r-5" />
              {' '}
              {I18n.t('BEE12' /* Início */)}
            </li>
            <li className="breadcrumb-item">{I18n.t('BEE1400' /* Movimentação */)}</li>
            <li className="breadcrumb-item">{I18n.t('BEE41' /* Expedição */)}</li>
            <li className="breadcrumb-item active">{I18n.t('BEE1363' /* Monitor de Expedição */)}</li>
          </ol>
        </div>
        <div className="d-flex align-items-center mb-md-3 mb-2">
          <h1 className="page-header mb-0">
            {I18n.t('BEE1363' /* Monitor de Expedição */)}
          </h1>
          <WikiHelp wikiPath={ROUTES.OUTBOUND_MONITOR_HELP} />
        </div>
        <div className="row m-l-1 mb-3">
          <DateRangePicker
            onChange={this.handleDateApplyEvent}
          >
            <button type="button" className="btn btn-inverse mr-2 text-truncate">
              <i className="fa fa-calendar fa-fw text-white-transparent-5 ml-n1" />
              <span>{currentRange}</span>
              <b className="caret" />
            </button>
          </DateRangePicker>
          <UncontrolledPopover trigger="hover" placement="top" target="dateRangePicker">
            <PopoverHeader>
              {I18n.t(
                'BEE3342',
                {
                  0: I18n.t('BEE3344' /* data de criação */),
                }, /* O intervalo segue o critério pela %{0} */
              )}
            </PopoverHeader>
          </UncontrolledPopover>
          <div className="ml-auto mr-2 mt-1">
            {!Permissions.checkPermission(ROUTES.P_OUTBOUND_MONITOR_MANAGE_FIELDS) && (
              <button
                type="button"
                className="btn btn-primary p-5 m-2"
                onClick={() => this.showPageLayoutModal()}
              >
                {I18n.t('BEE4439' /* Gerenciar Colunas */)}
              </button>
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12 text-right">
            <Panel>
              <PanelBody>
                <Nav tabs fill style={{ backgroundColor: 'lightgray' }}>
                  {usesCableCuttingPlan
                    && (
                    <NavItem>
                      <NavLink
                        className={this.state.activeTab === 'pendingCut' ? 'active' : ''}
                        onClick={() => {
                          this.toggleFilter('pendingCut');
                        }}
                        style={styleNavLink}
                      >
                        <span className="d-sm-none">pendingCut</span>
                        <span
                          className="d-sm-block d-none"
                          style={styleSpan}
                        >
                          {I18n.t('BEE1420' /* Corte de Cabos */)}
                        </span>
                      </NavLink>
                    </NavItem>
                    )}
                  <NavItem style={{ display: 'flex' }}>
                    <NavLink
                      className={this.state.activeTab === 'pendingPicking' ? 'active' : ''}
                      onClick={() => {
                        this.toggleFilter('pendingPicking');
                      }}
                      style={styleNavLink}
                    >
                      <span className="d-sm-none">pendingPicking</span>
                      <span
                        className="d-sm-block d-none"
                        style={styleSpan}
                      >
                        {I18n.t('BEE1365' /* Pendente Separação */)}

                      </span>
                    </NavLink>
                  </NavItem>
                  <NavItem style={{ display: 'flex' }}>
                    <NavLink
                      className={this.state.activeTab === 'picking' ? 'active' : ''}
                      onClick={() => {
                        this.toggleFilter('picking');
                      }}
                      style={styleNavLink}
                    >
                      <span className="d-sm-none">picking</span>
                      <span
                        style={styleSpan}
                        className="d-sm-block d-none"
                      >
                        {I18n.t('BEE1367' /* Em Separação */)}

                      </span>
                    </NavLink>
                  </NavItem>
                  <NavItem style={{ display: 'flex' }}>
                    <NavLink
                      className={this.state.activeTab === 'check' ? 'active' : ''}
                      onClick={() => {
                        this.toggleFilter('check');
                      }}
                      style={styleNavLink}
                    >
                      <span className="d-sm-none">check</span>
                      <span
                        style={styleSpan}
                        className="d-sm-block d-none"
                      >
                        {I18n.t('BEE37' /* Conferência */)}

                      </span>
                    </NavLink>
                  </NavItem>
                  <NavItem style={{ display: 'flex' }}>
                    <NavLink
                      className={this.state.activeTab === 'withdrawStore' ? 'active' : ''}
                      onClick={() => {
                        this.toggleFilter('withdrawStore');
                      }}
                      style={styleNavLink}
                    >
                      <span className="d-sm-none">withdrawStore</span>
                      <span
                        style={styleSpan}
                        className="d-sm-block d-none"
                      >
                        {I18n.t('BEE2963' /* Pendente de Faturamento */)}
                      </span>
                    </NavLink>
                  </NavItem>
                  <NavItem style={{ display: 'flex' }}>
                    <NavLink
                      className={this.state.activeTab === 'dockControl' ? 'active' : ''}
                      onClick={() => {
                        this.toggleFilter('dockControl');
                      }}
                      style={styleNavLink}
                    >
                      <span className="d-sm-none">dockControl</span>
                      <span
                        style={styleSpan}
                        className="d-sm-block d-none"
                      >
                        {I18n.t('BEE199' /* Doca */)}
                      </span>
                    </NavLink>
                  </NavItem>
                  <NavItem style={{ display: 'flex' }}>
                    <NavLink
                      className={this.state.activeTab === 'packingList' ? 'active' : ''}
                      onClick={() => {
                        this.toggleFilter('packingList');
                      }}
                      style={styleNavLink}
                    >
                      <span className="d-sm-none">packingList</span>
                      <span
                        style={styleSpan}
                        className="d-sm-block d-none"
                      >
                        {I18n.t('BEE1369' /* Embarque em Romaneio */)}

                      </span>
                    </NavLink>
                  </NavItem>
                  <NavItem style={{ display: 'flex' }}>
                    <NavLink
                      className={this.state.activeTab === 'consolidation' ? 'active' : ''}
                      onClick={() => {
                        this.toggleFilter('consolidation');
                      }}
                      style={styleNavLink}
                    >
                      <span className="d-sm-none">consolidation</span>
                      <span
                        style={styleSpan}
                        className="d-sm-block d-none"
                      >
                        {I18n.t('BEE1046' /* Consolidação */)}

                      </span>
                    </NavLink>
                  </NavItem>
                  <NavItem style={{ display: 'flex' }}>
                    <NavLink
                      className={this.state.activeTab === 'divergence' ? 'active' : ''}
                      onClick={() => {
                        this.toggleFilter('divergence');
                      }}
                      style={styleNavLink}
                    >
                      <span className="d-sm-none">divergence</span>
                      <span
                        style={styleSpan}
                        className="d-sm-block d-none"
                      >
                        {I18n.t('BEE176' /* Divergência */)}

                      </span>
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent style={{ padding: '0px', paddingBlock: '15px' }} activeTab={activeTab}>
                  <TabPane tabId="pendingCut">
                    {activeTab === 'pendingCut'
                      ? (
                        <List
                          startDate={startDate}
                          endDate={endDate}
                          currentRange={currentRange}
                          activeTab={activeTab}
                          pageLayout={pageLayout}
                        />
                      )
                      : null}
                  </TabPane>
                  <TabPane tabId="pendingPicking">
                    {activeTab === 'pendingPicking'
                      ? (
                        <List
                          startDate={startDate}
                          endDate={endDate}
                          currentRange={currentRange}
                          activeTab={activeTab}
                          pageLayout={pageLayout}
                        />
                      )
                      : null}
                  </TabPane>
                  <TabPane tabId="picking">
                    {activeTab === 'picking'
                      ? (
                        <List
                          startDate={startDate}
                          endDate={endDate}
                          currentRange={currentRange}
                          activeTab={activeTab}
                          pageLayout={pageLayout}
                        />
                      )
                      : null}
                  </TabPane>
                  <TabPane tabId="divergence">
                    {activeTab === 'divergence'
                      ? (
                        <List
                          startDate={startDate}
                          endDate={endDate}
                          currentRange={currentRange}
                          activeTab={activeTab}
                          pageLayout={pageLayout}
                        />
                      )
                      : null}
                  </TabPane>
                  <TabPane tabId="withdrawStore">
                    {activeTab === 'withdrawStore'
                      ? (
                        <List
                          startDate={startDate}
                          endDate={endDate}
                          currentRange={currentRange}
                          activeTab={activeTab}
                          pageLayout={pageLayout}
                        />
                      )
                      : null}
                  </TabPane>
                  <TabPane tabId="check">
                    {activeTab === 'check'
                      ? (
                        <List
                          startDate={startDate}
                          endDate={endDate}
                          currentRange={currentRange}
                          activeTab={activeTab}
                          pageLayout={pageLayout}
                        />
                      )
                      : null}
                  </TabPane>
                  <TabPane tabId="dockControl">
                    {activeTab === 'dockControl'
                      ? (
                        <List
                          startDate={startDate}
                          endDate={endDate}
                          currentRange={currentRange}
                          activeTab={activeTab}
                          pageLayout={pageLayout}
                        />
                      )
                      : null}
                  </TabPane>
                  <TabPane tabId="consolidation">
                    {activeTab === 'consolidation'
                      ? (
                        <List
                          startDate={startDate}
                          endDate={endDate}
                          currentRange={currentRange}
                          activeTab={activeTab}
                          pageLayout={pageLayout}
                        />
                      )
                      : null}
                  </TabPane>
                  <TabPane tabId="packingList">
                    {activeTab === 'packingList'
                      ? (
                        <List
                          startDate={startDate}
                          endDate={endDate}
                          currentRange={currentRange}
                          activeTab={activeTab}
                          pageLayout={pageLayout}
                        />
                      )
                      : null}
                  </TabPane>
                </TabContent>
              </PanelBody>
            </Panel>
            {this.createPageLayoutModal()}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.app.userLogged,
});

const mapDispatchToProps = (dispatch) => ({
  updatePageLayout: (pageLayout) => dispatch(updatePageLayout(pageLayout)),
  getPageLayout: (pageLayout) => dispatch(getPageLayout(pageLayout)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(OutboundMonitor));
